<template>
  <div>
    <modal
      :showClose="true"
      @close="$emit('close')"
      class="reaction-modal">

      <div slot="header" class="title mb-2">
        <div class="d-flex align-center justify-space-between text">
          <h3 slot="subHeader">
            score lower than the defined value set by merchant will automatically trigger a message to the emails listed
          </h3>
          
        </div>
        <div class="d-flex align-center justify-start">
          <hr style="margin: 10px; width: 100%;" />
        </div>
      </div>

      <div slot="body" class="body">
        <div v-if="showLoading" class="d-flex justify-center">
          <sb-loading-icon />
        </div>

        <ReactionEmailOption
          v-if="!showLoading"
          scoreType="nps"
          :value="alertData.get('nps')"
          @updateCheck="updateCheck"
          @handleChange="handleChange"
        />

        <ReactionEmailOption
          v-if="!showLoading"
          scoreType="crs"
          :value="alertData.get('crs')"
          @updateCheck="updateCheck"
          @handleChange="handleChange"
        />

        <ReactionEmailOption
          v-if="!showLoading"
          scoreType="product"
          :value="alertData.get('product')"
          @updateCheck="updateCheck"
          @handleChange="handleChange"
        />

        <ReactionEmailList
          v-if="!showLoading"
          @pushError="pushError"
          @removeError="removeError"
          @removeEmail="removeEmail"
          @pushEmail="pushEmail"
          :emails="emails"
        />

      </div>
      <div slot="action" class="modal-footer reaction-modal-footer">
        <p v-if="errors.includes('nps_error') || errors.includes('crs_error')||errors.includes('product_error')" class="text-danger">invalid score</p>
        <p v-if="errors.includes('email_error')" class="text-danger">invalid email</p>
        <p v-if="errors.includes('email_exists')" class="text-danger">email already registered</p>
        <p v-for="email in deleted_emails" class="text-dark">{{email}} has been removed</p>
        <button class="action-button button" @click="submit()">done</button>
      </div>
    </modal>

  </div>
</template>

<script>
import modal from '../../shared/Modal'
import  ReactionEmailOption from './ReactionEmailOption'
import  ReactionEmailList from './ReactionEmailList'
import { feedbackAPI } from "../../../services/api/feedbackAPI"

export default {
  components: {
    modal,
    ReactionEmailOption,
    ReactionEmailList,
  },
  data() {
    return {
      alertData: new Map([
        ['nps', {isChecked: false, score: null, hasError: false}],
        ["crs", {isChecked: false, score: null, hasError: false}],
        ["product", {isChecked: false, score: null, hasError: false}],
      ]),
      emails: [],
      errors: [],
      deleted_emails: [],
      showLoading: false,
    }
  },
  created(){
    this.loadData()
  },
  methods: {
    updateCheck(event, value, scoreType){
      if(!event){
        this.alertData.set(scoreType, {isChecked: false, score: null, hasError: false})
      }else{
        this.alertData.set(scoreType, {...value, isChecked: event })
      }
      this.validate()
    },
    handleChange(value, scoreType){
      this.alertData.set(scoreType, {...value})
      this.validate()
    },

    pushError(error){
      if (!this.errors.includes(error) && error !== "") {
        this.errors.push(error);
      }
    },

    removeError(errorsToRemove = []){
      this.errors = this.errors.filter((error) => {
        return !errorsToRemove.includes(error)
      })
    },
    pushEmail(email){
      this.emails.unshift(email);
    },

    removeEmail(key){
      const email_removed = this.emails[key];
      this.emails.splice(key, 1);

      this.deleted_emails.unshift(email_removed);
      const index = this.deleted_emails.indexOf(email_removed)

      setTimeout(function(emails, i) {
        emails.splice(i, 1);
      }, 3000, this.deleted_emails, index);
    },

    clearFields(){
      this.alertData.forEach((value, key) => {
        value.isChecked = false,
        value.score = null
        value.hasError = false
      }),
      this.emails =  [],
      this.errors = [],
      this.deleted_emails = []
      
    },

    getCurrentParams(){
      const params = {};
      for(const [key, value] of this.alertData.entries()) {
        params[key] = value;
      }
      params.emails=this.emails
      return params;
    },

    async submit() {
      const params = this.getCurrentParams();
      if(this.errors.length < 1){

        this.showLoading = true;
        const resp = await feedbackAPI.POSTFeedbackAlert(params)
        this.showLoading = false;
        this.$emit("close")
      }
    },

    validate(){
      this.alertData.forEach((value, key, map) => {
        const hasError = value.isChecked && (!value.score || value.score < 1 || value.score > 5 || value.score%1 > 0);

        if(hasError) {
          this.pushError(`${key}_error`);
        } else {
          this.removeError(`${key}_error`);
        }

        map.set(key, {
          ...value,
          hasError
        })
      })
    },

    async loadData(){

      this.showLoading = true;
      const reactionSettings = await feedbackAPI.GETFeedbackAlert()
      this.showLoading = false;

      this.alertData.forEach((value, key) => {
        const apiKey = `${key}_value`;
        
        if(reactionSettings[apiKey] !== null){
          this.alertData.set(key, {
            isChecked: true,
            score: reactionSettings[apiKey],
            hasError: false
          });
        }
      });
      this.emails = reactionSettings.emails
    }
  }

};
</script>

<style scoped>
  .body{
    margin:10px;
  }
</style>
